import Link from 'next/link';
import classNames from 'classnames';

import { SideNavSection } from '@interfaces/common';
import { hasAnchor } from '@utils/link';

import styles from './SideNav.module.css';

interface SideNavProps {
	activeHref: string;
	sections: SideNavSection[];
}

export const SideNav: React.VFC<SideNavProps> = ({ activeHref, sections }) => {
	return (
		<ul className={classNames('stack-block', styles.list)}>
			{sections.map(({ href, text }) => (
				<li key={href}>
					{hasAnchor(href) ? (
						<a
							className={classNames('fluid-font-t5-bold', styles['nav-link'], {
								[styles['is-active']]: activeHref === href,
							})}
							href={href}
						>
							{text}
						</a>
					) : (
						<Link href={href} passHref>
							<a
								className={classNames(
									'fluid-font-t5-bold',
									styles['nav-link'],
									{
										[styles['is-active']]: activeHref === href,
									}
								)}
								href="-"
							>
								{text}
							</a>
						</Link>
					)}
				</li>
			))}
		</ul>
	);
};
